module.exports = __webpack_public_path__ + "img/KSC02489.8912bc4f.jpg";